import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { aiApi } from "./aiApi";

const STYLE = {
  ok: "bg-emerald-50 text-emerald-700 border-emerald-200",
  down: "bg-rose-50 text-rose-700 border-rose-200",
  no_key: "bg-slate-50 text-slate-500 border-slate-200",
  loading: "bg-slate-50 text-slate-400 border-slate-200",
};
const DOT = { ok: "bg-emerald-500", down: "bg-rose-500", no_key: "bg-slate-300", loading: "bg-slate-300 animate-pulse" };

const fmtTok = (n) => (n >= 1e9 ? `${(n / 1e9).toFixed(1)}B` : n >= 1e6 ? `${(n / 1e6).toFixed(1)}M` : n >= 1e3 ? `${(n / 1e3).toFixed(0)}K` : `${n}`);

const RootsysQuota = ({ q }) => {
  if (!q || q.tokens_remaining == null) return null;
  const low = !q.active || (q.tokens_total && q.tokens_remaining / q.tokens_total < 0.1) || (q.days_remaining != null && q.days_remaining <= 3);
  const exp = q.expires_at ? new Date(q.expires_at).toLocaleDateString("ms-MY", { day: "numeric", month: "short", year: "numeric" }) : "-";
  return (
    <span data-testid="ai-llm-rootsys-quota" title={`Status: ${q.status || "-"} · Guna: ${fmtTok(q.tokens_used || 0)} · Tamat: ${exp}`}
      className={`inline-flex items-center h-6 px-2 rounded-full border text-[10.5px] font-semibold ${low ? "bg-amber-50 text-amber-700 border-amber-200" : "bg-sky-50 text-sky-700 border-sky-200"}`}>
      Baki rootsys: {fmtTok(q.tokens_remaining)}{q.tokens_total ? ` / ${fmtTok(q.tokens_total)}` : ""} token
      {q.days_remaining != null ? ` · ${Math.floor(q.days_remaining)} hari lagi` : ""}{q.active === false ? " · TIDAK AKTIF" : ""}
    </span>
  );
};

const label = (h) => (h.status === "ok" ? `Sihat ${(h.latency_ms / 1000).toFixed(1)}s` : h.status === "down" ? "Gagal" : h.status === "no_key" ? "Tiada key" : "Menyemak…");

export default function AILLMHealth({ providers }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async (refresh) => {
    setBusy(true);
    try { setData(await aiApi.llmHealth(refresh)); } catch { setData(null); } finally { setBusy(false); }
  };
  useEffect(() => { run(false); }, []);
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="ai-llm-health">
      <span className="text-[11px] font-bold text-slate-500">Status</span>
      {Object.entries(providers || {}).map(([k, p]) => {
        const h = busy && !data ? { status: "loading" } : data?.providers?.[k] || { status: "loading" };
        return (
          <span key={k} title={h.error || h.model || ""} data-testid={`ai-llm-health-${k}`}
            className={`inline-flex items-center gap-1 h-6 px-2 rounded-full border text-[10.5px] font-semibold ${STYLE[h.status]}`}>
            <span className={`h-1.5 w-1.5 rounded-full ${DOT[h.status]}`} />{p.label}: {label(h)}
          </span>
        );
      })}
      {data?.providers?.byta?.balance?.balance_usd != null && (
        <span data-testid="ai-llm-byta-balance" title={`Status: ${data.providers.byta.balance.status || "-"}`}
          className={`inline-flex items-center h-6 px-2 rounded-full border text-[10.5px] font-semibold ${data.providers.byta.balance.balance_usd < 5 ? "bg-amber-50 text-amber-700 border-amber-200" : "bg-sky-50 text-sky-700 border-sky-200"}`}>
          Baki Byta: ${data.providers.byta.balance.balance_usd.toFixed(2)}{data.providers.byta.balance.initial_usd ? ` / $${data.providers.byta.balance.initial_usd.toFixed(2)}` : ""}
        </span>
      )}
      <RootsysQuota q={data?.providers?.rootsys?.quota} />
      <button type="button" onClick={() => run(true)} disabled={busy} className="h-6 w-6 grid place-items-center rounded-full border border-slate-200 bg-white text-slate-500 hover:text-slate-800 disabled:opacity-50" data-testid="ai-llm-health-refresh" title="Semak semula">
        <RefreshCw className={`h-3 w-3 ${busy ? "animate-spin" : ""}`} />
      </button>
    </div>
  );
}
